module.exports = __webpack_public_path__ + "8663b240b1bb61d3eda67530e6ac4c45.svg";